import { Box, styled } from '@mui/material';

const CellWrapper = styled(Box)`
  width: 142px;
  display: grid;
  grid-template-columns: 40% 10% 50%;
  align-items: center;
  text-align: center;
  margin: auto;
`;

export default CellWrapper;
